import { combineReducers } from '@reduxjs/toolkit'
import { financialCalc } from './modules/financialCalc'
import { simulation } from './modules/simulation'
import { calcReversal } from './modules/calcReversal'
import { financialCalcReversal } from './modules/financialCalcReversal'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'

export const createAppReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    financialCalc: financialCalc.reducer,
    simulation: simulation.reducer,
    calcReversal: calcReversal.reducer,
    financialCalcReversal: financialCalcReversal.reducer,
  })

const createRootReducer =
  (history: History): ReturnType<typeof createAppReducer> =>
  (state, action) => {
    return createAppReducer(history)(state, action)
  }

export default createRootReducer
